import { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";



import {
  Breadcrumb,
  Button,
  DataTable,
  Dropdown,
  Icon,
  Notification,
  TextInput,
  TextArea,
  FileUploadV2,
  Modal
} from "pepsico-ds";

import "./idx-attribute-bulk-load.css";
import idxService from "./idx.service";
import { useUserProfile } from "../../common/user_profile_context";


const IdxPreProdAccessRequest = () => {
  const{ t, i18n } = useTranslation();
  const navigate = useNavigate();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const [accessType, setAccessType] = useState("self");
  const [operationType, setOperationType] = useState("");

const [applicationName, setApplicationName] = useState([]);
const [applicationRole, setApplicationRole] = useState([]);

const [applicationOptions, setApplicationOptions] = useState([]);
const [roleOptions, setRoleOptions] = useState([]);
const [assignedAttributes, setAssignedAttributes] = useState([]);

  const [attributeText, setAttributeText] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [isSuccess, setIsSuccess] = useState(false);

  const [showValidationError, setShowValidationError] = useState(false);
const [showErrorModal, setErrorShowModal] = useState(false);
const [isValid, setIsValid] = useState(false);
const [isSubmitting, setIsSubmitting] = useState(false);

const { userProfile } = useUserProfile();

const canAccessBulk =
  userProfile?.pepappiamcentralfeatures?.includes(
    "ApplicationAccessBulk"
  ) || false;

console.log("canAccessBulk =", canAccessBulk);



const [validationErrorCounts, setValidationErrorCounts] = useState({
  totalRow: 0,
  valid: 0,
  blankRow: 0,
  issues: 0,
});

const [validationErrorModalData, setValidationErrorModalData] = useState([]);
const [attributeError, setAttributeError] = useState("");

const validationErrorColumns = [
  {
    columnKey: "row",
    header: t("idx.row"),
    showColumnVisibility: true,
    initialSize: 140,
  },
  {
    columnKey: "message",
    header: t("idx.message"),
    showColumnVisibility: true,
    initialSize: 360,
  },
];


const closeModal = () => {
  setErrorShowModal(false);
};

const handleValidation = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response =
      await idxService.validateBulkPreProdFile(formData);

    const responseValidate = response;

    if (responseValidate?.valid) {
      setIsValid(true);
      setShowValidationError(false);
      setValidationErrorModalData([]);

      setValidationErrorCounts({
        totalRow: 0,
        valid: 0,
        blankRow: 0,
        issues: 0,
      });

      return;
    }

    setIsValid(false);

    if (
      responseValidate?.totalRows ||
      responseValidate?.acceptedRows ||
      responseValidate?.skippedRows ||
      responseValidate?.validationErrors?.length
    ) {
      setValidationErrorCounts({
        totalRow: responseValidate?.totalRows || 0,
        valid: responseValidate?.acceptedRows || 0,
        blankRow: responseValidate?.skippedRows || 0,
        issues:
          responseValidate?.validationErrors?.length || 0,
      });

      setShowValidationError(true);

      if (responseValidate?.validationErrors?.length) {
        setValidationErrorModalData(
          responseValidate.validationErrors.map((err) => ({
            row: err?.split(":")?.[0],
            message: err?.split(":")?.[1],
          }))
        );
      }
    }

    if (
      !responseValidate?.validationErrors?.length &&
      responseValidate?.status === "Failed"
    ) {
      setValidationErrorModalData([
        {
          row: "Validation",
          message:
            responseValidate?.errorMessage ||
            "File validation failed",
        },
      ]);

      setValidationErrorCounts({
        totalRow: 0,
        valid: 0,
        blankRow: 0,
        issues: 1,
      });

      setShowValidationError(true);
    }
  } catch (error) {
    setIsValid(false);
    setShowValidationError(true);

    setValidationErrorCounts({
      totalRow: 0,
      valid: 0,
      blankRow: 0,
      issues: 1,
    });

    setValidationErrorModalData([
      {
        row: "Validation",
        message: "Unable to validate file",
      },
    ]);
  }
};

const validateAttributeText = (value) => {
  if (!value?.trim()) {
    return "Attributes are required";
  }

  const entries = value
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);

 
  

  const seenAttributes = new Set();

  for (let i = 0; i < entries.length; i++) {
    const entry = entries[i];

    if (!entry.includes("=")) {
      return `Entry ${i + 1}: missing '=' separator`;
    }

    const [key, val] = entry.split("=");

    const attribute = key?.trim().toLowerCase();
    const valueText = val?.trim();

    if (!attribute.startsWith("pepapp")) {
      return `Entry ${i + 1}: attribute must start with 'pepapp'`;
    }

   if (
  !attribute.endsWith("status") &&
  !attribute.endsWith("roles") &&
  !attribute.endsWith("sectors")
) {
  return `Entry ${i + 1}: attribute must end with 'status', 'roles', or 'sectors'`;
}

    if (!valueText) {
      return `Entry ${i + 1}: value must not be blank`;
    }

    if (seenAttributes.has(attribute)) {
      return `Duplicate attribute '${attribute}' is not allowed`;
    }

    seenAttributes.add(attribute);
if (attribute.endsWith("status")) {
  const statusValues = valueText
    .split(/[|,]/)
    .map((item) => item.trim())
    .filter(Boolean);

  if (statusValues.length > 1) {
    return `Attribute '${attribute}' can only have one status value`;
  }

  if (statusValues[0] !== "Active") {
    return `Attribute '${attribute}' must be Active`;
  }
}


   if (attribute.endsWith("roles")) {
  const roles = valueText
    .split("|")
    .map((role) => role.trim());

  if (roles.some((role) => !role)) {
    return "Invalid roles format. Use Role1|Role2|Role3";
  }

  const uniqueRoles = new Set(
    roles.map((role) => role.toLowerCase())
  );

  if (uniqueRoles.size !== roles.length) {
    return "Duplicate roles are not allowed";
  }
}
  }


  return "";
};


  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
  if (isSuccess) {
    const timer = setTimeout(() => {
      setIsSuccess(false);
      navigate("/home");
    }, 4000);

    return () => clearTimeout(timer);
  }
}, [isSuccess, navigate]);

  // const applicationOptions = [
  //   {
  //     id: "AXON",
  //     displayText: "AXON",
  //   },
  //   {
  //     id: "BOBJ",
  //     displayText: "BOBJ",
  //   },
  //   {
  //     id: "CRIBL_STREAM",
  //     displayText: "Cribl Stream",
  //   },
  //   {
  //     id: "DAP",
  //     displayText: "DAP",
  //   },
  // ];

  // const roleOptions = [
  //   {
  //     id: "OWNER",
  //     displayText: t("idx.owner"),
  //   },
  //   {
  //     id: "ADMIN",
  //     displayText: t("idx.admin"),
  //   },
  //   {
  //     id: "EDITOR",
  //     displayText: t("idx.editor"),
  //   },
  //   {
  //     id: "READ_ONLY",
  //     displayText: t("idx.read_only"),
  //   },
  //   {
  //     id: "USER",
  //     displayText: t("idx.user"),
  //   },
  // ];

  // const assignedAttributes = [
  //   {
  //     attributeName: "pepappcriblstatus",
  //     attributeValue: "Active",
  //   },
  //   {
  //     attributeName: "pepappebiroles",
  //     attributeValue: "End_User",
  //   },
  // ];

useEffect(() => {
  loadApplications();
}, []);

const loadApplications = async () => {
  try {
    const response =
      await idxService.getPreProdApplications();

    const formattedApps = response.map((app) => ({
      id: app,
      displayText: app,
    }));

    setApplicationOptions(formattedApps);
  } catch (error) {
    console.error("Error fetching applications", error);
  }
};

useEffect(() => {
  if (applicationName?.length > 0) {
    getRoles(applicationName[0].id);
  }
}, [applicationName]);

const getRoles = async (appName) => {
  try {
    const response =
      await idxService.getPreProdIdxDetails(appName);

    const formattedRoles =
      response?.roles?.map((role) => ({
        id: role,
        displayText: role,
      })) || [];

    setRoleOptions(formattedRoles);

    setApplicationRole([]);
    setAssignedAttributes([]);
  } catch (error) {
    console.error("Error fetching roles", error);
  }
};

// useEffect(() => {
//   if (
//     applicationName?.length > 0 &&
//     applicationRole?.length > 0
//   ) {
//     getAssignedAttributes(
//       applicationName[0].id,
//       applicationRole[0].id
//     );
//   }
// }, [applicationName, applicationRole]);
useEffect(() => {
  if (!applicationName?.length) {
    setAssignedAttributes([]);
    return;
  }

  if (roleOptions.length > 0) {
    if (applicationRole?.length > 0) {
      getAssignedAttributes(
        applicationName[0].id,
        applicationRole[0].id
      );
    } else {
      setAssignedAttributes([]);
    }
  } else {
    // Application has no roles
    getAssignedAttributes(applicationName[0].id);
  }
}, [
  applicationName,
  applicationRole,
  roleOptions
]);

useEffect(() => {
  if (
    !userProfile?.pepappiamcentralfeatures?.includes(
      "ApplicationAccessBulk"
    ) &&
    accessType === "bulk"
  ) {
    setAccessType("self");
  }
}, [userProfile, accessType]);

const getAssignedAttributes = async (
  appName,
  role
) => {
  try {
    const response =
      await idxService.getPreProdIdxDetails(
        appName,
        role
      );

    if (!response?.attributes) {
      setAssignedAttributes([]);
      return;
    }

    const formattedAttributes =
      response.attributes
        .split(";")
        .map((item) => {
          const [attributeName, attributeValue] =
            item.split(":");

          return {
            attributeName: attributeName?.trim(),
            attributeValue: attributeValue?.trim(),
          };
        });

    setAssignedAttributes(formattedAttributes);
  } catch (error) {
    console.error(
      "Error fetching assigned attributes",
      error
    );
  }
};



const assignedAttributeColumns = useMemo(
  () => [
    {
      columnKey: "attributeName",
      header: t("idx.attribute_name"),
      initialSize: 250,
    },
    {
      columnKey: "attributeValue",
      header: t("idx.attribute_value"),
      initialSize: 250,
      cellData: (ctx) => (
        <span
          className={
            ctx.row.original.attributeValue === "Active"
              ? "attribute-pill-success"
              : "attribute-pill"
          }
        >
          {ctx.row.original.attributeValue}
        </span>
      ),
    },
  ],
  [t, i18n.language]
);

  const disableSubmit = () => {
    if (isSubmitting) {
return true;
}
   if (
  accessType === "bulk" &&
  (uploadedFiles.length === 0 || !isValid)
) {
  return true;
}

    if (operationType === "mirror") {
      return false;
    }

    // if (operationType === "application") {
    //   return !(applicationName?.length > 0 && applicationRole?.length > 0);
    // }
    if (operationType === "application") {
  if (!applicationName?.length) {
    return true;
  }

  // If roles exist, user must select one.
  if (roleOptions.length > 0) {
    return applicationRole.length === 0;
  }

  // If application has no roles, allow submit.
  return false;
}

   if (operationType === "attribute") {
  return (
    !attributeText?.trim() ||
    !!attributeError
  );
}

    return true;
  };
const handleTemplateDownload = async () => {
  try {
    const blob =
      await idxService.downloadBulkTemplate(
        "appaccesspreprod"
      );

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "PreProd_Access_Template.csv";

    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error(error);
  }
};

  // const handleSubmit = () => {
  //   console.log({
  //     accessType,
  //     operationType,
  //     applicationName,
  //     applicationRole,
  //     attributeText,
  //     uploadedFiles,
  //   });
  // };

// const handleSubmit = async () => {
//   try {
//     let payload = {};

//     if (operationType === "mirror") {
//       payload = {
//         type: "Mirror",
//       };
//     }

//     if (operationType === "application") {
//       payload = {
//         type: "Appspecific",
//         appName: applicationName?.[0]?.id,
//         appRole: applicationRole?.[0]?.id,
//         fieldDetails: assignedAttributes
//           .map(
//             (attr) =>
//               `${attr.attributeName}: ${attr.attributeValue}`
//           )
//           .join(";"),
//       };
//     }

//     if (operationType === "attribute") {
//       payload = {
//         type: "Attrspecific",
//         appRole: attributeText.trim(),
//       };
//     }

//     // Self Flow
//     if (accessType === "self") {
//       const response =
//         await idxService.submitPreProdApplicationAccess(
//           payload
//         );

//       console.log(response);
//       return;
//     }

//     // Bulk Flow
//     const formData = new FormData();

//     formData.append(
//       "csvFile",
//       uploadedFiles?.[0]
//     );

//     Object.keys(payload).forEach((key) => {
//       formData.append(key, payload[key]);
//     });

//     const response =
//       await idxService.submitBulkPreProdApplicationAccess(
//         formData
//       );

//     console.log(response);
//   } catch (error) {
//     console.error(error);
//   }

//   setIsSuccess(true);

// window.scrollTo({
//   top: 0,
//   behavior: "smooth",
// });
// };


const handleSubmit = async () => {
  if (isSubmitting) return;

  setIsSubmitting(true);
  try {
    let payload = {};

    if (operationType === "mirror") {
      payload = {
        type: "Mirror",
      };
    }

    // if (operationType === "application") {
    //   payload = {
    //     type: "Appspecific",
    //     appName: applicationName?.[0]?.id,
    //     appRole: applicationRole?.[0]?.id,
    //     fieldDetails: assignedAttributes
    //       .map(
    //         (attr) =>
    //           `${attr.attributeName}: ${attr.attributeValue}`
    //       )
    //       .join(";"),
    //   };
    // }

    if (operationType === "application") {
  payload = {
    type: "Appspecific",
    appName: applicationName?.[0]?.id,

    ...(applicationRole?.[0]?.id && {
      appRole: applicationRole[0].id,
    }),

    fieldDetails: assignedAttributes
      .map(
        (attr) =>
          `${attr.attributeName}: ${attr.attributeValue}`
      )
      .join(";"),
  };
}

 if (operationType === "attribute") {
  const error = validateAttributeText(
    attributeText
  );

  if (error) {
    setAttributeError(error);
    setIsSubmitting(false);
    return;
  }

  payload = {
    type: "Attrspecific",
    appRole: attributeText.trim(),
  };
}

    let response;

    if (accessType === "self") {
      response =
        await idxService.submitPreProdApplicationAccess(
          payload
        );
    } else {
      const formData = new FormData();

      formData.append(
        "csvFile",
        uploadedFiles?.[0]
      );

      Object.keys(payload).forEach((key) => {
        formData.append(key, payload[key]);
      });

      response =
        await idxService.submitBulkPreProdApplicationAccess(
          formData
        );
    }

if (
  response?.status === "Failed" ||
  response?.responseStatus === "Failed"
) {
  toast.error(
    response?.errorMessage ||
      "Request submission failed"
  );

  setIsSubmitting(false);
  return;
}

    setIsSuccess(true);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

  } catch (error) {
  console.error(error);

  toast.error(
    error?.response?.data?.errorMessage ||
      "Request submission failed"
  );

  setIsSubmitting(false);
}
};



  return (
    <>
    {showErrorModal && (
  <div className="validation-error-modal">
    <Modal
      size="large"
      className="validation-error-modal hide-rows-per-page"
      closeOnOutsideClick={false}
      onCloseModal={closeModal}
      showCloseButton
      showModal={showErrorModal}
      showAuxiliaryButton={false}
      showPrimaryButton={false}
      showSecondaryButton={false}
      title={`${t("idx.showing")} ${validationErrorCounts?.issues} ${t("idx.issues")}`}
      type="fluid"
    >
      <DataTable
      key={t("idx.row")}
        columns={validationErrorColumns}
        data={validationErrorModalData}
        pageIndex={0}
        pageSize={10}
        selection="single"
        size="large"
        showTableHeader
        showPagination
        showSearchOption={false}
        showColumnFilters={false}
      />
    </Modal>
  </div>
)}
      <div className="idx-main-container">
        <div
          className={isMobile ? "row" : "container"}
          style={{
            background: "none",
            boxShadow: "none",
            justifyContent: isMobile ? "center" : "",
          }}
        >
          <div
            style={{
              width: "100%",
              flex: 1,
            }}
          >

            {isSuccess && (
  <Notification
    className="mb-3"
    showActionButtons={false}
    showIcon
    showTitle
    title={t("idx.request_submitted_successfully")}
    type="success"
  />
)}
            <div
              className={`${
                isMobile ? "pl-4 pr-4 ml-4 mr-4" : ""
              } ad-main-heading-container`}
            >
              <Breadcrumb
                homeIcon={{
                    icon: "home",
                    onClick:()=>{
                    navigate("/home")
                    }
                }}
                breadcrumbs={[
                  {
                    label: t("menu.home"),
                  },
                  {
                    label: t("idx.application_access_preprod"),
                  },
                ]}
                className="idx-breadcrumb"
                useAnchor
              />

              <div className="ad-page-header">
                <div className="ad-main-heading">
                  {t("idx.application_access_preprod")}
                </div>
              </div>
            </div>

            <div
              className="card-layout reg-card mb-3 mb-md-0 active-directory-card-container idx-container"
              style={{
                flex: isMobile ? "unset" : "0 0 calc(66.666% - 7.5px)",
                width: isMobile ? "100%" : "auto",
                flexDirection: isMobile ? "column" : "row",
                gap: "1rem",
              }}
            >
              <div className="w-100">
                <div className="card card-content preprod-outer-card">
                  <div className="preprod-container">
                    {/* Raise Access */}
                    <div className="preprod-section-label">
                      {t("idx.raise_access_for")}
                    </div>

                    <div className="preprod-access-toggle">
                      <Button
                        text={t("idx.self")}
                        variant={
                          accessType === "self" ? "primary" : "secondary"
                        }
                        onClick={() => setAccessType("self")}
                      />
{/* 
                      <Button
                        text={t("idx.bulk")}
                        variant={
                          accessType === "bulk" ? "primary" : "secondary"
                        }
                        onClick={() => setAccessType("bulk")}
                      /> */}

                      {canAccessBulk && (
  <Button
    text={t("idx.bulk")}
    variant={
      accessType === "bulk" ? "primary" : "secondary"
    }
    onClick={() => setAccessType("bulk")}
  />
)}
                    </div>

                    {accessType === "bulk" && (
                      <div className="bulk-upload-section">
                        <div className="download-template-section">
                          <div className="download-template-label">
                            <Icon icon="download" size="18px" />

                            <div className="d-flex flex-column text-left">
                              <div className="download-template-heading">
                                {t("idx.download_excel_template")}
                              </div>
                            </div>
                          </div>

                          <Button
                            text={t("entraGuest.download")}
                            variant="primary"
                            onClick={handleTemplateDownload}
                          />
                        </div>

                        <div className="preprod-section-label">
                          {t("idx.file_upload")}
                        </div>

                        <FileUploadV2
                          accept=".csv,.xlsx,.xls"
                          buttonLabel={t("idx.file_upload")}
                          //   label={t("idx.file_upload")}
                          description={t("idx.drag_drop_file_here")}
                          type="default"
                          uploadIcon="cloud_upload"
                          variant="complete"
                          isShowUploadedFileCount={false}
                          helperText={t("idx.maximum_of_50_gpids")}
                          files={uploadedFiles}
                          disabled={uploadedFiles.length > 0}
                          multiple={false}
                          required={false}
             onUpdate={async (file) => {
  setUploadedFiles([file]);
  setErrorShowModal(false);
setIsValid(false);

  setShowValidationError(false);
  setValidationErrorModalData([]);

  setValidationErrorCounts({
    totalRow: 0,
    valid: 0,
    blankRow: 0,
    issues: 0,
  });

  await handleValidation(file);
}}
                        onDelete={(i) => {
  const filteredFiles = uploadedFiles.filter(
    (_, index) => index !== i
  );

  setUploadedFiles(filteredFiles);

  setShowValidationError(false);
  setErrorShowModal(false);

  setValidationErrorModalData([]);

  setValidationErrorCounts({
    totalRow: 0,
    valid: 0,
    blankRow: 0,
    issues: 0,
  });

  setIsValid(false);
}}
                        />

                        {showValidationError && (
  <div className="idx-validation-error-section">
    <Icon
      icon="error"
      size="18px"
      className="main-icon"
    />

    <div className="idx-validation-error-main-section">
      <div className="error-heading mb-2">
        {t("idx.validation_failed")}
      </div>

      <div className="error-desc mb-2">
        {t("idx.validation_failed_desc")}
      </div>

      <div className="error-tags-section">
        <div className="total-row-tag">
          <Icon icon="table_rows" size="18px" />
          <div>
            {`${validationErrorCounts.totalRow} ${t("idx.total_rows")}`}
          </div>
        </div>

        <div className="valid-tag">
          <Icon icon="check" size="18px" />
          <div>
            {`${validationErrorCounts.valid} ${t("idx.valid")}`}
          </div>
        </div>

        <div className="blank-row-tag">
          <Icon icon="border_clear" size="18px" />
          <div>
            {`${validationErrorCounts.blankRow} ${t("idx.blank_rows")}`}
          </div>
        </div>

        <div className="issues-tag">
          <Icon icon="error" size="18px" />
          <div>
            {`${validationErrorCounts.issues} ${t("idx.issues")}`}
          </div>
        </div>

        <div
          className={`show-issues-tag ${
            !validationErrorModalData.length
              ? "disabled"
              : ""
          }`}
          onClick={() => {
            if (validationErrorModalData.length) {
              setErrorShowModal(true);
            }
          }}
        >
          {t("idx.show_issues")}
        </div>
      </div>
    </div>
  </div>
)}
                      </div>
                    )}

                    {/* Operation Type */}

                    <div className="preprod-section-label">
                      {t("idx.type_of_operation")}
                    </div>

                    <div className="preprod-cards">
                      {/* Mirror */}

                      <div
                        className={`preprod-card ${
                          operationType === "mirror" ? "selected" : ""
                        }`}
                        onClick={() => setOperationType("mirror")}
                      >
                        <div className="preprod-card-icon">
                          <Icon icon="copy" />
                        </div>

                        {operationType === "mirror" && (
                          <Icon
                            className="preprod-selected-icon"
                            icon="check_circle"
                          />
                        )}

                        <div className="preprod-card-title">
                          {t("idx.mirror_production_access")}
                        </div>

                        <div className="preprod-card-text">
                          {t("idx.mirror_production_access_desc")}
                        </div>
                      </div>

                      {/* Application */}

                      <div
                        className={`preprod-card ${
                          operationType === "application" ? "selected" : ""
                        }`}
                        onClick={() => setOperationType("application")}
                      >
                        <div className="preprod-card-icon">
                          <Icon icon="web_asset" />
                        </div>

                        {operationType === "application" && (
                          <Icon
                            className="preprod-selected-icon"
                            icon="check_circle"
                          />
                        )}

                        <div className="preprod-card-title">
                          {t("idx.application_specific")}
                        </div>

                        <div className="preprod-card-text">
                          {t("idx.application_specific_desc")}
                        </div>
                      </div>

                      {/* Attribute */}

                      <div
                        className={`preprod-card ${
                          operationType === "attribute" ? "selected" : ""
                        }`}
                        onClick={() => setOperationType("attribute")}
                      >
                        <div className="preprod-card-icon">
                          <Icon icon="label" />
                        </div>

                        {operationType === "attribute" && (
                          <Icon
                            className="preprod-selected-icon"
                            icon="check_circle"
                          />
                        )}

                        <div className="preprod-card-title">
                          {t("idx.attribute_based")}
                        </div>

                        <div className="preprod-card-text">
                          {t("idx.attribute_based_desc")}
                        </div>
                      </div>
                    </div>

                    {/* Mirror Message */}

                    {operationType === "mirror" && (
                      <Notification
                        showActionButtons={false}
                        showIcon
                        type="info"
                        title={t("idx.mirror_notification")}
                      />
                    )}

                    {/* Application Access */}

                    {operationType === "application" && (
                      <>
                        <div className="preprod-dropdown-row">
                          <div className="preprod-dropdown-column">
                            <Dropdown
                              childList={applicationOptions}
                              label={t("idx.application_name")}
                              placeholder={t(
                                "RequestGPIDForNonEmployee.select_btn_label",
                              )}
                              isRequired
                              selection="single"
                              selectedValue={applicationName}
                              setSelectedValue={setApplicationName}
                            />
                          </div>

                          {/* <div className="preprod-dropdown-column">
                            <Dropdown
                              childList={roleOptions}
                              label={t("idx.application_role")}
                              placeholder={t(
                                "RequestGPIDForNonEmployee.select_btn_label",
                              )}
                              isRequired
                              selection="single"
                              selectedValue={applicationRole}
                              setSelectedValue={setApplicationRole}
                            />
                          </div> */}
                          {roleOptions.length > 0 && (
  <div className="preprod-dropdown-column">
    <Dropdown
      childList={roleOptions}
      label={t("idx.application_role")}
      placeholder={t(
        "RequestGPIDForNonEmployee.select_btn_label"
      )}
      isRequired
      selection="single"
      selectedValue={applicationRole}
      setSelectedValue={setApplicationRole}
    />
  </div>
)}
                        </div>

                        {/* {applicationName?.length > 0 &&
                          applicationRole?.length > 0 && (
                            <div className="preprod-attributes">
                              <div className="preprod-section-label">
                                {t("idx.assigned_attributes")}
                              </div>

                              <DataTable
                              key={`assigned-attributes-${i18n.language}`}
                                columns={assignedAttributeColumns}
                                data={assignedAttributes}
                                enableSorting={true}
                                pageIndex={0}
                                pageSize={10}
                                selection="single"
                                size="large"
                                showTitle={false}
                                showTableHeader
                                showSearchOption={false}
                                showColumnFilters={false}
                                showDescription={false}
                                showPagination={false}
                              />
                            </div>
                          )} */}

                          {applicationName?.length > 0 &&
  (roleOptions.length === 0 ||
    applicationRole?.length > 0) &&
  assignedAttributes.length > 0 && (
    <div className="preprod-attributes">
      <div className="preprod-section-label">
        {t("idx.assigned_attributes")}
      </div>

      <DataTable
        key={`assigned-attributes-${i18n.language}`}
        columns={assignedAttributeColumns}
        data={assignedAttributes}
        enableSorting={true}
        pageIndex={0}
        pageSize={10}
        selection="single"
        size="large"
        showTitle={false}
        showTableHeader
        showSearchOption={false}
        showColumnFilters={false}
        showDescription={false}
        showPagination={false}
      />
    </div>
)}
                      </>
                    )}

                    {/* Attribute Access */}

                    {operationType === "attribute" && (
                      <>
                        {/* <TextInput
                                                    label="Attributes to be Assigned"
                                                    placeholder="Placeholder"
                                                    value={
                                                        attributeText
                                                    }
                                                    onChange={(e) =>
                                                        setAttributeText(
                                                            e
                                                                .target
                                                                .value
                                                        )
                                                    }
                                                /> */}
                        <TextArea
                          title={t("idx.attributes_to_be_assigned")}
                          label={t("idx.attributes_to_be_assigned")}
                          placeholder={t("idx.enter_attributes")}
                          rows={4}
                          style={{ width: "100%", maxWidth: "100%" }}
                         onChange={(e) => {
  const value = e.target.value;

  setAttributeText(value);

  setAttributeError(
    validateAttributeText(value)
  );
}}
                          value={attributeText}
                          showToolbar={false}
                          showCharacterCount={false}
                          showLabelIcon={false}
                          maxLength={500}
                        />

                        {attributeError && (
  <div
    style={{
      color: "#C12C01",
      fontSize: "12px",
      marginTop: "4px",
    }}
  >
    {attributeError}
  </div>
)}

                        <div className="attribute-info-box">
                          <Icon icon="info" />

                          <div className="attribute-info-content">
                            <div className="attribute-info-title">
                              {t("idx.attribute_info_prefix")}{" "}
                              <span className="attribute-info-title-bold">
                                {t("idx.attribute_info_bold")}
                              </span>{" "}
                              {t("idx.attribute_info_suffix")}
                            </div>

                            <div className="attribute-info-sample">
                              {t("idx.attribute_example")}
                            </div>

                            <div className="attribute-info-desc">
                              {t("idx.attribute_info_desc")}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="idx-footer mt-3">
  <div className="row footer-row-with-footer-buttons">
    <div className="footer-buttons">
      <div className="col-md-auto align-self-center d-flex mb-3 mb-md-0 px-md-0 justify-content-center">
        <Button
          className="search-user-cancel-button mr-md-2 my-0"
          size="medium"
          text={t("RequestGPIDForNonEmployee.cancel_btn_label")}
          variant="tertiary"
          onClick={() => navigate(-1)}
        />
      </div>

      <div className="col-md-auto align-self-center d-flex mb-3 mb-md-0">
        <Button
          className="search-user-select-button request-button my-0 px-3 justify-content-center"
          size="medium"
          text={t("nonArExtension.submit")}
          variant="primary"
          disabled={disableSubmit()}
          onClick={handleSubmit}
        />
      </div>
    </div>
  </div>
  <ToastContainer position="bottom-center" />
</div>

      {/* <div className="idx-footer mt-3">
        <div className="row footer-row-with-footer-buttons">
          <div className="footer-buttons">
            <div className="col-md-auto align-self-center d-flex mb-3 mb-md-0 px-md-0 justify-content-center">
              <Button
                text={t("RequestGPIDForNonEmployee.cancel_btn_label")}
                variant="tertiary"
                onClick={() => navigate(-1)}
              />
            </div>

            <div className="col-md-auto align-self-center d-flex mb-3 mb-md-0">
              <Button
                text={t("nonArExtension.submit")}
                variant="primary"
                disabled={disableSubmit()}
                onClick={handleSubmit}
              />
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default IdxPreProdAccessRequest;
